import { addAlert, showModal } from "@/redux/message/messageSlice";
import {
  SetVote,
  downvote,
  hideSbcSet,
  markSbcSetAsFavorite,
  markSbcSetSolved,
  upvote,
} from "@/redux/sbcs/sbcSetsSlice";
import { updateSbcsSolved } from "@/redux/sbcs/sbcsSlice";
import { AppDispatch } from "@/redux/store";
import { undoVoteSbcSet, voteSbcSet } from "@repo/shared/api";
import type { TranslateFn } from "@repo/shared/i18n";

type T = TranslateFn<"sbcs">;

export function handleFavoriteToggle(dispatch: AppDispatch, sbcSet: any, t: T) {
  const isFavorite = sbcSet?.isFavorite;
  const setName = sbcSet?.name;

  dispatch(
    markSbcSetAsFavorite({ setId: sbcSet?.id, isFavorite: !isFavorite }),
  );

  dispatch(
    addAlert({
      description: isFavorite
        ? t("alerts.removedFavorite", { name: setName })
        : t("alerts.markedFavorite", { name: setName }),
      type: "success",
    }),
  );
}

export function handleHideToggle(dispatch: AppDispatch, sbcSet: any, t: T) {
  const isHidden = sbcSet?.isHidden;

  dispatch(hideSbcSet({ setId: sbcSet?.id, isHidden: !isHidden }));

  dispatch(
    addAlert({
      description: isHidden
        ? t("alerts.removedHidden", { name: sbcSet?.name })
        : t("alerts.markedHidden", { name: sbcSet?.name }),
      type: "success",
    }),
  );
}

export function handleCompleteToggle(dispatch: AppDispatch, sbcSet: any, t: T) {
  const isCompleted = sbcSet?.solvedCount === sbcSet?.sbcsCount;

  dispatch(markSbcSetSolved({ setId: sbcSet?.id, didComplete: !isCompleted }));
  dispatch(updateSbcsSolved({ setId: sbcSet?.id, solved: !isCompleted }));

  dispatch(
    addAlert({
      title: t("alerts.completedSbcTitle"),
      description: isCompleted
        ? t("alerts.removed", { name: sbcSet?.name })
        : t("alerts.completed", { name: sbcSet?.name }),
      type: "success",
    }),
  );
}

export function handleVote(
  dispatch: AppDispatch,
  sbcSet: any,
  vote: SetVote,
  userUuid: string | null,
) {
  if (!userUuid) {
    dispatch(
      showModal({
        modalType: "login-required",
        freeFeatureLoggedInRequiredHook: "upvote/downvote-sbc",
      }),
    );
    return;
  }

  const setId = +sbcSet?.id;
  if (!setId) return;

  const isUpvote = vote === "UPVOTE";
  /* The request is decided here, not in the reducer: the set page reads the
     set from whichever slice holds it, and only the caller knows both. */
  const undo = isUpvote ? sbcSet?.wasUpvoted : sbcSet?.wasDownvoted;

  if (undo) undoVoteSbcSet(setId, vote);
  else voteSbcSet(setId, vote);

  dispatch(isUpvote ? upvote({ setId }) : downvote({ setId }));
}
